export const aureaColors = {
  primaryBackground: '#252728',
  onImageBackground: '#FFFFFF',
  onIconsAndTextButtons: '#141619',
  onIconsAndTextButtonsVariant: '#141619',
  secondaryBackground: '#1d1c1a',
  selectedAndDetailBackground: '#413D39',
  borderLine: '#515151',
  placeholderText: '#4F4A48',
  menuBackground: '#DADBD7',
  currentStep: '#DADBD7',
  onSecondaryAndDetailBackground: '#FFFFFF',
  hoverMenuBackground: '#F8F8F4',
  mainFocused: '#D7A461',
  highlight: '#B68150',
  tradingDown: '#B68150',
  tradingUp: '#B68150',
  off: '#67696A',
  lower: '#6f614f',
  footerBackground: '#252728',
  onFooterBackground: '#FFFFFF',
  popupWindow: '#DADBD7',
  popupWindowTitle: '#000000',
  iconsOnFooterBackground: '#D7A461',
  primaryDisabledBackground: '#3C3835',
  secondaryDisabledBackground: '#212324',
  primaryDisabledText: '#252728',
  secondaryDisabledText: '#4B4C4C',
  scrollOnDetailBackground: '#717171',
  scrollOnPrimaryBackground: '#585959',
  infoBackground: '#383737',
  nextStep: '#393D41',
  previousStep: '#696969',
  iconsOnMenuBackground: '#B3B6B7',
  mainFocusedSoothing: '#423D2A',
  highlightSoothing: '#412919',
  pillBorder: '#E88D45',
  pillBackgroundGloomy: '#C49B7D',
  pillBackgroundLight: '#37332C',
  dividerOnPrimaryBackground: '#433E39',
  label: '#A4A8A9',
  homePageBackground: '#FFFFFF',
  onHomePageBackground: '#000000',
  refreshButton: '#DADBD7',
  dashboardDivider: '#585252',
  star: '#FFCF06',
  up: '#02A578',
  down: '#C44444',
  inert: '#516579',
  scrollOnInfoBackground: '#FFFFFF',
  actionBar: '#312F2F',
  onInfoBackground: '#FFFFFF',
  onPrimaryBackground: '#FFFFFF',
  lockedBackground: 'rgba(37, 39, 40, 0.65)',
  hoverHighlight: '#F0BB8A',
  variantOnInfoBackground: '#FFFFFF',
  variantOnPrimaryBackground: '#FFFFFF',
  graphBackground: '#202222',
  disabledAndHoverOnInfoBackground: '#585959',
  disabledOnPrimaryBackground: '#4B4949',
  iconsSelectedOnMenu: '#B68150',
  selectedBarOnMenu: '#B68150',
  selectedTextButtonMenu: '#B68150',
  newsBackground: '#2d2f31',
};
